<template>
  <ion-page>
    <ion-content
      class="main-background"
      :fullscreen="true"
      slot="fixed"
      :scroll-y="false"
    >
      <div class="release-safe-area"></div>
      <ion-button
        v-show="!isLandscapeMode"
        v-on:click="returnBack()"
        :class="['header-sm-button', 'bg-transparent', 'top-level', !isReleaseGuide ? 'white-regular' : '']"
      >
        <ion-icon slot="end" :icon="closeOutline"></ion-icon>
      </ion-button>
      <ion-button
        v-show="isLandscapeMode && isMobile"
        v-on:click="returnBack('Programs')"
        class="header-sm-button bg-transparent top-level white-regular"
      >
        <ion-icon slot="end" :icon="chevronDown"></ion-icon>
      </ion-button>
      <ion-button
        v-show="isReleaseVideo && !isLandscapeMode && isMobile"
        @click="setFullscreenMode(true)"
        class="header-sm-button header-sm-button-right top-level bg-transparent white-regular"
      >
        <ion-icon slot="end" :icon="resize"></ion-icon>
      </ion-button>

      <ion-router-outlet id="release-router"></ion-router-outlet>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { Release } from "@/model/release.model";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import {
  IonButton,
  IonContent,
  IonIcon,
  IonPage,
  IonRouterOutlet,
  useBackButton,
} from "@ionic/vue";
import {
  chevronDown,
  closeOutline,
  documentOutline,
  // fileTrayFullOutline,
  filmOutline,
  musicalNotesOutline,
  resize,
} from "ionicons/icons";
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "ReleaseMain",
  components: {
    IonContent,
    IonPage,
    IonIcon,
    IonRouterOutlet,
    IonButton,
  },

  setup() {
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const releaseEntity = inject("release") as Release;

    return {
      musicalNotesOutline,
      filmOutline,
      documentOutline,
      closeOutline,
      chevronDown,
      resize,
      isMobile,
      releaseEntity,
      globalContext,
      // fileTrayFullOutline,
    };
  },

  data() {
    return {
      isLandscapeMode: false,
    };
  },

  mounted() {
    try {
      this.$nextTick(() => {
        useBackButton(10, () => {
          this.returnBack();
        });

        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
              ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      });
    } catch (ex) {
      //not supported
    }
  },

  computed: {
    isReleaseVideo() {
      return this.$router.currentRoute.value.path === "/video";
    },
    isReleaseMusic() {
      return this.$router.currentRoute.value.path === "/music";
    },
    isReleaseGuide() {
      return this.$router.currentRoute.value.path === "/guide";
    },
  },

  methods: {
    returnBack(componentName?: string) {
      this.setFullscreenMode(false);
      this.$router.replace({ name: componentName ? componentName : "ReleasePage" });
    },
    navigate(releaseDetail: string) {
      this.$router.push({
        name: releaseDetail,
      });
    },
    setFullscreenMode(value: boolean) {
      this.isLandscapeMode = value;
      try {
        if (this.isMobile && this.isLandscapeMode)
          ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE);
        else if (this.isMobile) {
          ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT).then(
            () => {
              setTimeout(() => {
                ScreenOrientation.unlock();
              }, 3000);
            }
          );
        }
      } catch (ex) {
        //not supported
      }
    },
  },
});
</script>

<style scoped>
.release-safe-area {
  width: 100vw;
  height: var(--ion-safe-area-top);
}
.release-close-button {
  font-size: 2em !important;
}

@media (min-width: 1281px) {
  .header-sm-button-right {
    display: none;
  }
}
</style>